/**
 * Base del API normalizada — garantiza el sufijo `/api` (las rutas del backend viven
 * bajo /api en todos los entornos). Tolera que NUXT_PUBLIC_API_URL venga con o sin /api
 * (p.ej. staging seteado como https://api-staging.factorix.cloud → se completa a .../api).
 * Local (http://localhost/factorix/api) y prod (https://api.factorix.cloud/api) no cambian.
 */
export function useApiBase(): string {
  const raw = (useRuntimeConfig().public.apiUrl || '').replace(/\/+$/, '')
  return /\/api$/.test(raw) ? raw : `${raw}/api`
}
